import type { Project } from '@/services/types';

const KeyOutcomesTab = ({ data }: { data?: Project }) => {
  return (
    <div className='w-full space-y-2 break-words'>
      <p className='text-sm font-bold text-primary'>Key Outcomes</p>
      <p className='overflow-hidden whitespace-pre-wrap break-words text-sm text-muted-foreground'>
        {data?.keyOutcomes || 'No outcomes provided.'}
      </p>
    </div>
  );
};

export default KeyOutcomesTab;